import React from 'react';
import { GameStateProvider } from './GameStateContext';
import ViewGame2 from '../../pages/2ViewGame.js';


const ViewGameRoute = () => (
  <GameStateProvider>
    <ViewGame2 />
  </GameStateProvider>
);

export default ViewGameRoute;
